import { useEffect } from 'react';

/**
 * Locks body scroll (adds html.no-scroll) when `active` true.
 * Works well for iOS to minimize layout jumps.
 */
export function useModalScrollLock(active) {
  useEffect(() => {
    const root = document.documentElement;
    if (active) {
      root.classList.add('no-scroll');
    } else {
      root.classList.remove('no-scroll');
    }
    return () => root.classList.remove('no-scroll');
  }, [active]);
}
